const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPathology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M26.5,29h-21c-1.4,0-2.6-1.2-2.6-2.6V5.6 C2.9,4.2,4.1,3,5.5,3h21c1.4,0,2.6,1.2,2.6,2.6v20.8C29.1,27.8,27.9,29,26.5,29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M14.6,8.5c0-0.6,0.3-1.2,0.7-1.6V5.8 c0-0.2-0.2-0.3-0.3-0.3h-4.7c-0.2,0-0.3,0.2-0.3,0.3v4.6h5.4v-0.2C14.9,9.7,14.7,9.2,14.6,8.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10.9,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 5.4,
    height: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M10,11.6v0.8c0,0.2,0.2,0.3,0.3,0.3H15 c0.2,0,0.3-0.2,0.3-0.3v-0.8H10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M10.9,13.2v1.7c0,0.1,0.1,0.2,0.2,0.2h3 c0.1,0,0.2-0.1,0.2-0.2v-1.7H10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12,15.3v1.3c0,0.1,0,0.2,0.1,0.2h1.1 c0,0,0.1-0.1,0.1-0.2v-1.3H12z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 16.7,
    cy: 8.5,
    r: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M18.7,8.7c0,0.5-0.2,0.9-0.5,1.2 c2.1,1,3.6,3.1,3.6,5.6c0,3.4-2.8,6.2-6.3,6.2c-2.1,0-3.9-1-5-2.5h5.9c0.1,0,0.2-0.1,0.2-0.2v-0.4c0-0.1-0.1-0.2-0.2-0.2H9.1 c-0.1,0-0.2,0.1-0.2,0.2V19L9,19.1c1.3,2.3,3.8,3.9,6.6,3.9c4.2,0,7.6-3.4,7.6-7.5C23.1,12.5,21.3,9.9,18.7,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M22.8,25.3h-4.3V24c0-0.1-0.1-0.2-0.2-0.2 h-0.7c0.2-0.3,0.2-0.6,0.2-0.9c0-1-0.8-1.9-1.9-1.9c-1,0-1.9,0.8-1.9,1.9c0,0.3,0.1,0.7,0.2,0.9h-0.7c-0.1,0-0.2,0.1-0.2,0.2v1.3H9 c-0.1,0-0.2,0.1-0.2,0.2v1c0,0.1,0.1,0.2,0.2,0.2h13.8c0.1,0,0.2-0.1,0.2-0.2v-1C23,25.4,22.9,25.3,22.8,25.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2C355E"
    },
    cx: 22.1,
    cy: 16.2,
    r: 3.4
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "24.4,15.2 23.1,15.2 23.1,13.8  21.2,13.8 21.2,15.2 19.8,15.2 19.8,17 21.2,17 21.2,18.4 23.1,18.4 23.1,17 24.4,17  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathology);
export default __webpack_public_path__ + "static/media/pathology.2fd7bd58b8b22f79c29072af0aa9a9cf.svg";
export { ForwardRef as ReactComponent };